var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2450 2256.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.28,1435.55c-36.89,76.81-55.88,163.64-54.92,253.16-794.02,27.48-791.43-1132.95,1.43-1103.28,3.42,80.64,22.51,160.3,55.28,231.37-197.34-74.7-428.58,86.58-440.06,285.04-37.89,236.31,228.55,417.3,438.27,333.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2449.53,1175.87c13.93,317.9-303.26,581.51-609.28,550.88,6.41-86.81-14.39-171.44-43.58-250.93,205.05,78.4,461.48-94.34,435.43-322.12-.96-8.4-1.93-16.79-2.82-25.19-21.97-208.21-273.85-359.63-474.14-259.74,45.9-77.64,73.76-158.32,83.4-243.87,306.2-32.15,625.35,233.25,610.98,550.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M899.59,1589.14c-2.23,6.96-4.29,13.93-6.07,20.98,1.7-7.05,3.75-14.02,6.07-20.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M916.37,1548.06c-3.3,6.7-6.34,13.48-9.2,20.36,2.77-6.88,5.8-13.66,9.2-20.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M919.95,88.66c-.8,.54-1.52,1.07-2.32,1.61-1.16,.71-2.32,1.43-3.39,2.23,1.16-.8,2.23-1.52,3.39-2.32,.71-.45,1.52-.98,2.32-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1237.58,2255.84c-1.07,0-2.23,.09-3.3,.09-1.07,.09-2.14,.09-3.3,.09-1.79,0-3.66,0-5.54-.09,3.21,0,6.52,0,9.82-.09h2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1493.42,1886.32c-5.98,8.93-12.41,17.59-19.29,25.9,6.79-8.3,13.22-16.97,19.29-25.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1742.56,1539.58c122.21,338.78-185.62,716.44-542.47,716.44-441.75,0-714.77-599.85-394.8-919.86,48.04,39.92,116.09,96.53,164.22,136.36-269.93,322.84,144.93,725.26,437.82,503.46,63.69-48.23,108.98-117.1,128.21-194.65,118.87-479.4-881.4-675.4-867.47-1183.76-16.78-192.99,76.12-390.56,238.04-499.44,7.43-5.17,15.39-10.64,23.04-15.45,.09,0,.09-.09,.18-.09,493.46-314.86,1101.03,339.12,725.01,808.68h-.8l-19.02,27.86-1.34,1.96c-55.81-39.74-119.75-95.73-169.67-134.93,193.29-214.53,36.23-563.75-243.96-566.24-243.65-15.44-425.38,295.64-293.16,500.17,208.86,275.59,673.28,477.87,800.28,775.55h0c2.68,8.57,13.22,35.9,15.9,43.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M917.62,90.18c-1.16,.8-2.23,1.52-3.39,2.32,1.07-.8,2.23-1.52,3.39-2.23,.8-.54,1.52-1.07,2.32-1.61-.8,.54-1.61,1.07-2.32,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M914.23,92.5c1.07-.8,2.23-1.52,3.39-2.23v-.09c-1.16,.8-2.23,1.52-3.39,2.32Zm3.39-2.23v-.09c.71-.45,1.52-.98,2.32-1.52m-2.32,1.61v-.09"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7396ab072031db912a489e34f4a10771.svg";
export { ForwardRef as ReactComponent };